import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { VerifiedBadge } from "@/components/ui/VerifiedBadge";
import { formatCount } from "@/lib/utils/format";
import { cn } from "@/lib/utils/cn";

interface TopicCardProps {
  topic: { id: string; name: string; slug: string; description: string | null; color: string; subscriber_count: number; post_count: number; is_verified: boolean; is_featured: boolean };
  index?: number;
  className?: string;
}

export function TopicCard({ topic, index = 0, className }: TopicCardProps) {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.04 }}>
      <Link to={`/topics/${topic.slug}`}
        className={cn("card p-4 flex flex-col gap-3 hover:shadow-card-hover hover:-translate-y-0.5 transition-all group", className)}>
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${topic.color}20` }}>
              <div className="w-3.5 h-3.5 rounded-full" style={{ backgroundColor: topic.color }} />
            </div>
            <div>
              <div className="flex items-center gap-1">
                <h3 className="text-sm font-semibold text-foreground group-hover:text-brand transition-colors">{topic.name}</h3>
                {topic.is_verified && <VerifiedBadge size="xs" />}
              </div>
              {topic.is_featured && <span className="text-2xs text-text-subtle">Featured</span>}
            </div>
          </div>
        </div>
        {topic.description && (
          <p className="text-xs text-text-muted line-clamp-2 leading-relaxed">{topic.description}</p>
        )}
        <div className="flex items-center gap-3 text-xs text-text-subtle">
          <span><strong className="text-foreground">{formatCount(topic.subscriber_count)}</strong> members</span>
          <span><strong className="text-foreground">{formatCount(topic.post_count)}</strong> posts</span>
        </div>
      </Link>
    </motion.div>
  );
}
